import createReducer from "../../reducers/createReducer";
import {
  BULK_UPDATE_EMPLOYEES_LOADING,
  BULK_UPDATE_EMPLOYEES_SUCCESS,
  BULK_UPDATE_EMPLOYEES_ERROR,
  ONBOARD_EMPLOYEES_LOADING,
  ONBOARD_EMPLOYEES_SUCCESS,
  ONBOARD_EMPLOYEES_ERROR,
  ONBOARD_EMPLOYEES_VERIFY_LOADING,
  ONBOARD_EMPLOYEES_VERIFY_SUCCESS,
  ONBOARD_EMPLOYEES_VERIFY_ERROR,
  INVITE_EMPLOYEES_LOADING,
  INVITE_EMPLOYEES_SUCCESS,
  INVITE_EMPLOYEES_ERROR,
  INVITE_PENDING_EMPLOYEES_LOADING,
  INVITE_PENDING_EMPLOYEES_SUCCESS,
  INVITE_PENDING_EMPLOYEES_ERROR,
  UPDATE_EMPLOYEE_LOADING,
  UPDATE_EMPLOYEE_SUCCESS,
  UPDATE_EMPLOYEE_ERROR,
  CREATE_PAYSTACK_PROFILE_LOADING,
  CREATE_PAYSTACK_PROFILE_SUCCESS,
  CREATE_PAYSTACK_PROFILE_ERROR,
  OVERTIME_LIST_LOADING,
  OVERTIME_LIST_SUCCESS,
  OVERTIME_LIST_ERROR,
  GET_OVERTIME_LOADING,
  GET_OVERTIME_SUCCESS,
  GET_OVERTIME_ERROR,
  APPROVE_OVERTIME_LOADING,
  APPROVE_OVERTIME_SUCCESS,
  APPROVE_OVERTIME_ERROR,
  REJECT_OVERTIME_LOADING,
  REJECT_OVERTIME_SUCCESS,
  REJECT_OVERTIME_ERROR,
  LEAVE_LIST_LOADING,
  LEAVE_LIST_SUCCESS,
  LEAVE_LIST_ERROR,
  CREATE_LEAVE_LOADING,
  CREATE_LEAVE_SUCCESS,
  CREATE_LEAVE_ERROR,
  GET_COMPANY_PAYMENT_LOADING,
  GET_COMPANY_PAYMENT_ERROR,
  GET_COMPANY_PAYMENT_SUCCESS,
  GET_WITHDRAWAL_CATEGORIES_ERROR,
  GET_WITHDRAWAL_CATEGORIES_LOADING,
  GET_WITHDRAWAL_CATEGORIES_SUCCESS,
  LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_SUCCESS,
  LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_ERROR,
  LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_LOADING,
  UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_LOADING,
  UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_SUCCESS,
  UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_ERROR,
  EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_LOADING,
  EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_SUCCESS,
  EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_ERROR,
  EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_LOADING,
  EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_SUCCESS,
  EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_ERROR,
  LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_LOADING,
  LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_SUCCESS,
  LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_ERROR,
  INVITE_COMPANY_ADMIN_LOADING,
  INVITE_COMPANY_ADMIN_SUCCESS,
  INVITE_COMPANY_ADMIN_ERROR,
  CHANGE_EMPLOYEE_PERMISSION_LOADING,
  CHANGE_EMPLOYEE_PERMISSION_SUCCESS,
  CHANGE_EMPLOYEE_PERMISSION_ERROR,

} from "./types";
import {
  GET_EMPLOYEE_SUCCESS,
  EMPLOYEE_LIST_SUCCESS,
} from "../dashboard/types";

let initialState = {
  loading: false,
  error: null,
  approveSuccess: null,
  approveError: null,
  inviteSuccess: null,
  invitePendingEmployeesSuccess: null,
  invitePendingEmployeesError: null,
  rejectSuccess: null,
  rejectError: null,
  onBoardSuccess: null,
  onBoardVerifySuccess: null,
  onBoardVerifyError: null,
  updateEmployeeSuccess: null,
  overtimeList: null,
  overtimeInfo: null,
  leaveList: null,
  createLeaveSuccess: null,
  createLeaveError: null,
  companyPaymentList: null,
  companyPaymentListError: null,
  compnanyPaymentError: null,
  withdrawalLimitCategories: null,
  withdrawalLimitCategoriesLoading: false,
  listEmployeeCompanyJoinRequests: null,
  listEmployeeCompanyJoinRequestsLoading: false,
  listEmployeeCompanyJoinRequestsError: null,
  updateEmployeeCompanyJoinRequestSuccess: null,
  updateEmployeeCompanyJoinRequestError: null,
  updateEmployeeCompanyJoinRequestLoading: false,
  employeeCompanyJoinRequestApproveLoading: null,
  employeeCompanyJoinRequestApproveSuccess: null,
  employeeCompanyJoinRequestApproveError: null,
  employeeCompanyJoinRequestRejectLoading: false,
  employeeCompanyJoinRequestRejectSuccess: null,
  employeeCompanyJoinRequestRejectError: null,
  // Audit logs are keyed by join-request id so the drawer can look up its own
  // slice without collisions when multiple drawers are opened in a session.
  joinRequestAuditLogs: {},
  joinRequestAuditLogsLoading: false,
  joinRequestAuditLogsError: null,
  joinRequestAuditLogsForId: null,
  inviteCompanyAdminLoading: false,
  inviteCompanyAdminSuccess: null,
  inviteCompanyAdminError: null,
  // Change-permission (ordinary / hr / admin) — success carries the updated
  // user object so the caller can reconcile local state without re-fetching.
  changeEmployeePermissionLoading: false,
  changeEmployeePermissionSuccess: null,
  changeEmployeePermissionError: null,
};

function resolveState(state = {}, newState = {}) {
  return Object.assign({}, state, newState)
}


export const companyDashboardReducer = createReducer(initialState, {
  [INVITE_COMPANY_ADMIN_ERROR](state, action) {
    return resolveState(state, {
      inviteCompanyAdminLoading: false,
      inviteCompanyAdminSuccess: null,
      inviteCompanyAdminError: action.payload
    })
  },
  [INVITE_COMPANY_ADMIN_LOADING](state, action) {
    return resolveState(state, {
      inviteCompanyAdminLoading: true,
      inviteCompanyAdminSuccess: null,
    })
  },
  [INVITE_COMPANY_ADMIN_SUCCESS](state, action) {
    return resolveState(state, {
      inviteCompanyAdminLoading: false,
      inviteCompanyAdminSuccess: action.payload,
    })
  },
  [EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_ERROR](state, action) {
    return resolveState(state, {
      employeeCompanyJoinRequestRejectLoading: false,
      employeeCompanyJoinRequestRejectSuccess: null,
      employeeCompanyJoinRequestRejectError: action.payload
    })
  },
  [EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_LOADING](state, action) {
    return resolveState(state, {
      employeeCompanyJoinRequestRejectLoading: true,
      employeeCompanyJoinRequestRejectSuccess: null,
    })
  },
  [EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_SUCCESS](state, action) {
    return resolveState(state, {
      employeeCompanyJoinRequestRejectLoading: false,
      employeeCompanyJoinRequestRejectSuccess: action.payload,
    })
  },

  [EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_ERROR](state, action) {
    return resolveState(state, {
      employeeCompanyJoinRequestApproveLoading: false,
      employeeCompanyJoinRequestApproveSuccess: null,
      employeeCompanyJoinRequestApproveError: action.payload
    })
  },
  [EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_LOADING](state, action) {
    return resolveState(state, {
      employeeCompanyJoinRequestApproveLoading: true,
      employeeCompanyJoinRequestApproveSuccess: null,
    })
  },
  [EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_SUCCESS](state, action) {
    return resolveState(state, {
      employeeCompanyJoinRequestApproveLoading: false,
      employeeCompanyJoinRequestApproveSuccess: action.payload,
    })
  },

  [UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_ERROR](state, action) {
    return resolveState(state, {
      updateEmployeeCompanyJoinRequestLoading: false,
      updateEmployeeCompanyJoinRequestSuccess: null,
      updateEmployeeCompanyJoinRequestError: action.payload
    })
  },
  [UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_LOADING](state, action) {
    return resolveState(state, {
      updateEmployeeCompanyJoinRequestLoading: true,
      updateEmployeeCompanyJoinRequestSuccess: null,
    })
  },
  [UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_SUCCESS](state, action) {
    return resolveState(state, {
      updateEmployeeCompanyJoinRequestLoading: false,
      updateEmployeeCompanyJoinRequestSuccess: action.payload,
      listEmployeeCompanyJoinRequests: resolveState(state.listEmployeeCompanyJoinRequests || {}, {
        data: state.listEmployeeCompanyJoinRequests?.data?.map(
          request => request.id === action.employee_company_join_request_id ? action.payload : request
        )
      })
    })
  },
  [LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_ERROR](state, action) {
    return resolveState(state, {
      listEmployeeCompanyJoinRequestsLoading: false,
      listEmployeeCompanyJoinRequests: null,
      listEmployeeCompanyJoinRequestsError: action.payload
    })
  },
  [LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_LOADING](state, action) {
    return resolveState(state, {
      listEmployeeCompanyJoinRequestsLoading: true,
      listEmployeeCompanyJoinRequests: null,
    })
  },
  [LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_SUCCESS](state, action) {
    return resolveState(state, {
      listEmployeeCompanyJoinRequestsLoading: false,
      listEmployeeCompanyJoinRequests: action.payload,
    })
  },
  [LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_LOADING](state, action) {
    return resolveState(state, {
      joinRequestAuditLogsLoading: true,
      joinRequestAuditLogsError: null,
      joinRequestAuditLogsForId: action.request_id,
    })
  },
  [LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_SUCCESS](state, action) {
    return resolveState(state, {
      joinRequestAuditLogsLoading: false,
      joinRequestAuditLogsError: null,
      joinRequestAuditLogs: resolveState(state.joinRequestAuditLogs || {}, {
        [action.request_id]: action.payload,
      }),
    })
  },
  [LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_ERROR](state, action) {
    return resolveState(state, {
      joinRequestAuditLogsLoading: false,
      joinRequestAuditLogsError: action.payload,
    })
  },
  [CHANGE_EMPLOYEE_PERMISSION_LOADING](state) {
    return resolveState(state, {
      changeEmployeePermissionLoading: true,
      changeEmployeePermissionError: null,
      changeEmployeePermissionSuccess: null,
    })
  },
  [CHANGE_EMPLOYEE_PERMISSION_SUCCESS](state, action) {
    return resolveState(state, {
      changeEmployeePermissionLoading: false,
      changeEmployeePermissionSuccess: action.payload,
    })
  },
  [CHANGE_EMPLOYEE_PERMISSION_ERROR](state, action) {
    return resolveState(state, {
      changeEmployeePermissionLoading: false,
      changeEmployeePermissionError: action.payload,
    })
  },
  [GET_WITHDRAWAL_CATEGORIES_ERROR](state, action) {
    return resolveState(state, {
      withdrawalLimitCategoriesLoading: false,
      withdrawalLimitCategories: null,
      error: action.payload
    })
  },
  [GET_WITHDRAWAL_CATEGORIES_LOADING](state, action) {
    return resolveState(state, {
      withdrawalLimitCategoriesLoading: true,
      withdrawalLimitCategories: null,
    })
  },
  [GET_WITHDRAWAL_CATEGORIES_SUCCESS](state, action) {
    return resolveState(state, {
      withdrawalLimitCategoriesLoading: false,
      withdrawalLimitCategories: action.payload,
      createWithdrawalLimitCategorySuccess: null,

    })
  },
  [BULK_UPDATE_EMPLOYEES_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      bulkUpdateSuccess: null,
      error: null,
    });
  },
  [BULK_UPDATE_EMPLOYEES_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      bulkUpdateSuccess: action.payload,
      error: null,
    });
  },
  [BULK_UPDATE_EMPLOYEES_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      bulkUpdateSuccess: null,
      error: action.payload,
    });
  },
  [ONBOARD_EMPLOYEES_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      onBoardSuccess: null,
      error: null,
    });
  },
  [ONBOARD_EMPLOYEES_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      onBoardSuccess: action.payload,
      error: null,
    });
  },
  [ONBOARD_EMPLOYEES_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      onBoardSuccess: null,
      error: action.payload,
    });
  },
  [ONBOARD_EMPLOYEES_VERIFY_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      onBoardVerifySuccess: null,
      onBoardVerifyError: null,
      error: null,
    });
  },
  [ONBOARD_EMPLOYEES_VERIFY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      onBoardVerifySuccess: action.payload,
      onBoardVerifyError: null,
      error: null,
    });
  },
  [ONBOARD_EMPLOYEES_VERIFY_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      onBoardVerifySuccess: null,
      onBoardVerifyError: action.payload,
      error: null,
    });
  },
  [INVITE_EMPLOYEES_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      inviteSuccess: null,
      error: null,
    });
  },
  [INVITE_EMPLOYEES_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      inviteSuccess: action.payload,
      error: null,
    });
  },
  [INVITE_EMPLOYEES_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      inviteSuccess: null,
      error: action.payload,
    });
  },
  [INVITE_PENDING_EMPLOYEES_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      invitePendingEmployeesSuccess: null,
      invitePendingEmployeesError: null,
      error: null,
    });
  },
  [INVITE_PENDING_EMPLOYEES_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      invitePendingEmployeesSuccess: action.payload,
      invitePendingEmployeesError: null,
      error: null,
    });
  },
  [INVITE_PENDING_EMPLOYEES_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      invitePendingEmployeesSuccess: null,
      invitePendingEmployeesError: action.payload,
      error: action.payload,
    });
  },
  [GET_EMPLOYEE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      updateEmployeeSuccess: null,
      error: null,
    });
  },
  [EMPLOYEE_LIST_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      onBoardSuccess: null,
      updateEmployeeSuccess: null,
      error: null,
    });
  },
  [UPDATE_EMPLOYEE_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      updateEmployeeSuccess: null,
      error: null,
    });
  },
  [UPDATE_EMPLOYEE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      updateEmployeeSuccess: action.payload,
      error: null,
    });
  },
  [UPDATE_EMPLOYEE_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      updateEmployeeSuccess: null,
      error: action.payload,
    });
  },
  [CREATE_PAYSTACK_PROFILE_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      updateEmployeeSuccess: null,
      error: null,
    });
  },
  [CREATE_PAYSTACK_PROFILE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      updateEmployeeSuccess: action.payload,
      error: null,
    });
  },
  [CREATE_PAYSTACK_PROFILE_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      updateEmployeeSuccess: null,
      error: action.payload,
    });
  },
  [OVERTIME_LIST_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      overtimeList: null,
      approveSuccess: null,
      approveError: null,
      rejectSuccess: null,
      rejectError: null,
      error: null,
    });
  },
  [OVERTIME_LIST_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      overtimeList: action.payload,
      error: null,
    });
  },
  [OVERTIME_LIST_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      overtimeList: null,
      error: action.payload,
    });
  },
  [GET_OVERTIME_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      overtimeInfo: null,
      approveSuccess: null,
      approveError: null,
      rejectSuccess: null,
      rejectError: null,
      error: null,
    });
  },
  [GET_OVERTIME_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      overtimeInfo: action.payload,
      error: null,
    });
  },
  [GET_OVERTIME_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      overtimeInfo: null,
      error: action.payload,
    });
  },
  [APPROVE_OVERTIME_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      approveSuccess: null,
      approveError: null,
    });
  },
  [APPROVE_OVERTIME_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      approveSuccess: action.payload,
      approveError: null,
    });
  },
  [APPROVE_OVERTIME_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      approveSuccess: null,
      approveError: action.payload,
    });
  },
  [REJECT_OVERTIME_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      rejectSuccess: null,
      rejectError: null,
    });
  },
  [REJECT_OVERTIME_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      rejectSuccess: action.payload,
      rejectError: null,
    });
  },
  [REJECT_OVERTIME_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      rejectSuccess: null,
      rejectError: action.payload,
    });
  },
  [LEAVE_LIST_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      leaveList: null,
      createLeaveSuccess: null,
      createLeaveError: null,
      error: null,
    });
  },
  [LEAVE_LIST_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      leaveList: action.payload,
      error: null,
    });
  },
  [LEAVE_LIST_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      leaveList: null,
      error: action.payload,
    });
  },
  [CREATE_LEAVE_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      createLeaveSuccess: null,
      createLeaveError: null,
    });
  },
  [CREATE_LEAVE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      createLeaveSuccess: action.payload,
      createLeaveError: null,
    });
  },
  [CREATE_LEAVE_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      createLeaveSuccess: null,
      createLeaveError: action.payload,
    });
  },
  [GET_COMPANY_PAYMENT_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      companyPaymentList: action.payload,
      companyPaymentListError: null
    })
  },
  [GET_COMPANY_PAYMENT_LOADING](state, action) {
    return Object.assign(
      {}, state, {
      loading: true,
      companyPaymentList: null,
      companyPaymentListError: null
    }
    )
  },
  [GET_COMPANY_PAYMENT_ERROR](state, action) {
    return Object.assign(
      {}, state, {
      loading: false,
      companyPaymentList: null,
      companyPaymentListError: action.payload
    }
    )
  }
});
